import Icon, { ICON_NAME } from "../../../components/Icon";
import { datetime } from "../../../util/library/datetime";
import { durationTxt } from "../../../util/varibles/global";
import { useProcessData } from "./ProcessDataContext";

export default function OperationSummary({ total_diesel, total_fuel }: { total_diesel?: number, total_fuel?: number }) {
    const [start] = useProcessData(state => state.start);
    const [finish] = useProcessData(state => state.finish);
    // const operation = useSelector(selectOpDetail.operation);
    // console.log(operation);
    return <div>
        <div className="flex items-center">
            <Icon icon={ICON_NAME.CLOCK} />

            <div className="flex gap-1 items-center text-[15px]">
                <div className="text-comment">Time, duration:</div>

                <div className="flex items-center">
                    <span>{datetime(start).format("YYYY-MM-DD, HH:mm")}</span>
                    <div className="arrow-right" />
                    <span>{finish ? datetime(finish).format("YYYY-MM-DD, HH:mm") : "--"},</span>
                    <span className="ml-1">{finish ? durationTxt(finish - start) : "--"}</span>
                </div>
            </div>
        </div>

        <div className="flex items-center gap-5">
            <div className="flex items-center text-[15px] gap-1">
                <div className="text-comment">
                    DG - ∑ Power consumption:
                </div>

                <div>
                    {total_diesel ? `${total_diesel.toFixed(2)}(kW)` : "--"}
                </div>
            </div>

            <div className="flex items-center text-[15px] gap-1">
                <div className="text-comment">
                    AE - ∑ fuel consumption:
                </div>

                <div>
                    {total_fuel ? `${total_fuel.toFixed(2)}(l)` : "--"}
                </div>
            </div>
        </div>
    </div>
}